export default "__VITE_ASSET__CqUzznQu__"